// Auto-refactored from translations.js on 2026-08-19
// Locale: mk

const mk = {
  wieMoeglich: { question: 'Како е тоа можно?', answer: 'Го преосмисливме синџирот на вредност.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Патот STIG ROCK',
    fazit: 'Скратениот синџир на снабдување ги елиминира најголемите трошочни позиции.',
    fazitBigPre: 'Ова овозможува попуст до',
    fazitBigValue: '80%',
    steps: [ 'Рудник', 'Брусилница', 'Сертификација', 'Краен купувач' ]
  },
  nav: { language: 'Јазик', contact: 'Контакт' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Единствена можност',
    subtitle: 'Градење богатство ориентирано кон иднината.',
    description: 'STIG ROCK е меѓународна платформа која им нуди на луѓето пристап до природни дијаманти, одржлива изградба на богатство и уникатна заедница.',
    scroll: 'Скролајте за да откриете'
  },
  disclaimer: {
    overline: 'Правна напомена',
    title: 'Disclaimer',
    paragraphs: [
      'Оваа презентација служи исклучиво за информирање и не претставува финансиски, инвестициски или даночен совет.',
      'STIG ROCK не е финансиски производ, туку се однесува на природни Diamond како реални средства.',
      'За развој на вредноста, добивката или приносите не се презема никаква гаранција. Минатите случувања не се индикација за идните резултати.',
      'Сите прикажани пресметки во врска со провизиите се само примери и исто така не претставуваат гаранција.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'ИЗГРАДЕН', 'НА СТРУКТУРА' ],
    body: 'STIG Group е меѓународен конзорциум, изграден на јасност, одговорност и долгорочна вредност. Секој бренд, секој проект и секое Partner-ство следи еден единствен стандард — без кратенки, без исклучоци.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'ИЗГРАДЕН', 'НА СТРУКТУРА' ],
        body: 'STIG Group е меѓународен конзорциум, изграден на јасност, одговорност и долгорочна вредност. Секој бренд, секој проект и секое Partner-ство следи еден единствен стандард — без кратенки, без исклучоци.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'СВЕТОТ НА', 'ЕКСКЛУЗИВНИ Diamond' ],
        body: 'STIG ROCK е модерен концепт на STIG Group, кој ги поврзува висококвалитетните GIA-сертифицирани Diamond со транспарентни структури и ексклузивно корисничко искуство. Јасни планови за решенија, професионална обработка и меѓународна ориентација.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'МЕЃУНАРОДНА', 'ТРГОВИЈА СО Diamond' ],
        body: 'STIG International е дел од STIG Group и е специјализиран за меѓународна трговија со GIA-сертифицирани Diamond. Фокус на квалитет, доверба и модерни трговски структури со глобални Partner-ства.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ОДГОВОРНОСТ', 'ОД САМИОТ РУДНИК' ],
        body: 'Ethical Mines се залага за одговорно ископување, потекло кое може да се следи и конфликт-слободни Diamond. Од рудникот до пазарот — целосна документација за транспарентност, интегритет и долгорочна одговорност по целиот синџир на снабдување.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Дијаманти',
    stigDrawback: 'Реален чувар на вредност',
    overline: 'Можности',
    title: 'Можности за градење богатство',
    subtitle: 'Споредба на вообичаените патишта.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex или Крпито',
        drawback: 'високо шпекулативно, непредвидливо, комплексно'
      },
      {
        tag: 'Акции',
        name: 'Берзанско тргување',
        drawback: 'ризик од флуктуации, потребно знаење, временски ангажман'
      },
      {
        tag: 'Крипто',
        name: 'Тргување',
        drawback: 'волатилност, регулаторен ризик, безбедносни пропусти'
      }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: 'Потценетата можност',
    body: 'Diamond со години се вбројуваат меѓу формите на инвестирање со најстабилна вредност и најголем потенцијал, но досега само малкумина го користеа овој потенцијал.',
    callout: 'Со нашиот STIG ROCK за прв пат им овозможуваме на сите пристап до овие извонредни можности.'
  },
  wertentwicklung: {
    overline: 'Развој на вредноста 1995 — 2025',
    title: 'Приказна за вредноста.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: 'Развој од 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Главни причини',
    title: 'Шест причини за Diamond',
    lead: 'Diamond се реални средства кои постојат независно од валутите и финансиските системи — и со векови ја зачувуваат својата вредност.',
    items: [
      {
        n: '01',
        title: 'Стабилност отпорна на кризи',
        body: 'Гаранција за реална вредност. Независно од валути и финансиски системи.'
      },
      {
        n: '02',
        title: 'Ултимативна мобилност',
        body: 'Мали, лесни за криење и транспортирање.'
      },
      {
        n: '03',
        title: 'Диверзификација и реткост',
        body: 'Тесни грла во понудата и природна ограниченост.'
      },
      { n: '04', title: 'Долгорочен раст', body: '+185% од 1995 година.' },
      {
        n: '05',
        title: 'Транспарентност и ексклузивност',
        body: '4-те C како гаранција: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Резерва на кралските семејства',
        body: 'Дури и кралските семејства користат Diamond како резерва на богатство.'
      }
    ]
  },
  markt: {
    overline: 'Волумен на пазарот',
    title: '99 — 108 Mrd. USD',
    sub: 'Трговски волумен во 2025 година',
    forecast: 'Прогноза до ~2032 / 2034: околу 140 – 168 Mrd. USD со умерен раст (~4 – 5 % p.a.).',
    source: 'Извор: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Иновација',
    title: 'Иновација. За прв пат во светот.',
    body: 'STIG ROCK е првата платформа во светот што им овозможува на луѓето да остварат пасивен приход на пазарот на Diamond, покрај зголемувањето на вредноста.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Регистарски бр. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'За компанијата',
    titleLines: [ 'МЕЃУНАРОДНА', 'СТРУКТУРА', 'ЈАСНА ВИЗИЈА' ],
    body: 'STIG ROCK е основан за да го направи пазарот на Diamond потранспарентен, помодерен и поориентиран кон клиентите — со фокус на доверба, безбедност и долгорочна структура.'
  },
  sicherheit: {
    overline: 'Квалитет и безбедност',
    title: 'Gemological Institute of America',
    body: 'Сертифицирана експертиза за вашите Diamond. GIA го проценува секој камен со највисока прецизност и долгогодишно искуство — сигурни проценки на вредноста за нашата компанија и нашите клиенти.',
    transparency: 'Секој Diamond ги исполнува највисоките стандарди за квалитет и е проверен и сертифициран од реномирани организации. Секој камен е единствен и добива индивидуален сертификат.'
  },
  plaene: {
    overline: 'Solution планови (SP)',
    title: 'Единствена иновација на производ',
    sub: 'Шест степенувани Solution планови — од $1K до $100K+, секој со растечки попуст месечно и во текот на целиот период.',
    recommended: 'Популарно',
    oneYear: '1 година',
    rowLabels: {
      delivery: 'Време на испорака',
      price: 'Цена на производот',
      carat: 'Karat',
      monthly: 'Попуст (месечно)',
      totalDiscount: 'Попуст (вкупно)',
      duration: 'Времетраење'
    },
    headers: {
      plan: 'План',
      from: 'Од',
      carat: 'Karat',
      monthly: 'Попуст / месец',
      total: 'Попуст вкупно',
      duration: 'Времетраење'
    },
    duration: '1 година',
    footnote: 'Сите цени се без гаранција и зависат од квалитетот, побарувачката и актуелниот развој на пазарот. Solution плановите се можни и на 2 години.'
  },
  plaeneVIP: {
    overline: 'Solution планови + VIP-пакет',
    title: 'Повеќе придобивки со VIP-Paket',
    sub: 'Комбинирај го твојот Solution Plan со VIP-Paket и искористи дополнителни ценовни предности од до 3 %. Така го зголемуваш вкупниот попуст и обезбедуваш уште поповолни услови.',
    rowLabels: {
      delivery: 'Време на испорака',
      price: 'Цена на производот',
      carat: 'Karat',
      monthly: 'Попуст (месечно)',
      totalDiscount: 'Попуст (вкупно)',
      vip1: 'VIP-пакет 1 (+1%)',
      vip2: 'VIP-пакет 2 (+2%)',
      vip3: 'VIP-пакет 3 (+3%)'
    },
    footnote: 'Сите цени се без гаранција и зависат од квалитетот, побарувачката и актуелниот развој на пазарот.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Повеќе придобивки со VIP-Paket',
    sub: 'Комбинирај го твојот Solution Plan со VIP-Paket и искористи дополнителни ценовни предности од до 3 %. Така го зголемуваш вкупниот попуст и обезбедуваш уште поповолни услови.',
    options: [
      {
        key: 'deliver',
        title: 'Повеќе придобивки со VIP-Paket',
        body: 'Diamond (Karat) по цената на вашиот DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Продажба нам',
        body: 'Можете да ни ги препродадете вашите Diamond нам по куповната цена што сте ја платиле.'
      },
      {
        key: 'sellThirdParty',
        title: 'Продажба на трети лица',
        body: 'Можете да ги препродадете вашите Diamond на трети лица.'
      }
    ],
    footnote: '*DS-Plan означува Solution план.'
  },
  tradWeg: {
    overline: 'Традиционална трговија',
    title: 'Традиционалниот пат',
    sub: 'Пред еден Diamond да стигне до крајниот клиент, се создаваат значителни трговски маржи преку посредниците, трговијата на големо и мало, во споредба со цената на суровиот дијамант од рудникот.',
    steps: [
      { title: 'Рудник', subtitle: 'Сурови Diamond' },
      { title: 'Посредник', subtitle: 'Набавка на сурови Diamond' },
      { title: 'Брусилница', subtitle: 'Брусење во накитни Diamond' },
      { title: 'Сертификација', subtitle: 'преку признати институти како GIA' },
      { title: 'Берза на Diamond', subtitle: 'Продажба на трговија на големо' },
      { title: 'Трговија на големо', subtitle: 'Продажба на трговија на мало' },
      { title: 'Трговија на мало', subtitle: 'на пр. јувелири' },
      { title: 'Крајни клиенти', subtitle: 'Купување на Diamond' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-пакети',
    sub: 'Важат 12 месеци за сите ваши потпишани Solution планови. Во зависност од VIP-пакетот: +1% до +3% дополнителен попуст',
    cardKicker: 'дополнително – на сите',
    cardKicker2: 'Solution планови',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Попустите стануваат заштеди',
      body: 'Месечна заштеда наместо месечен трошок. Од попустите се создаваат заштеди – а тие ги плаќаат токму работите за кои инаку секој месец плаќате од сопствен џеб.',
      line1Label: 'DS-Plan од',
      line1Value: '$5.000',
      line2Label: 'мес. попуст',
      line2Value: '3%',
      line3Label: 'VIP-пакет 3',
      line3Value: '+3%',
      resultLabel: 'мес. заштеди',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Како е тоа можно?',
    title: 'Ние го редефиниравме синџирот на вредност.',
    traditionalTitle: 'Традиционалниот пат',
    traditionalSteps: [
      'Рудник — Сурови Diamond',
      'Посредник — Набавка',
      'Брусилница — Брусење',
      'Сертификација (GIA)',
      'Берза на Diamond — Трговија на големо',
      'Трговија на големо → Трговија на мало',
      'Јувелири → Краен клиент'
    ],
    traditionalNote: 'Пред еден Diamond да стигне до крајниот клиент, се создаваат значителни трговски маржи преку посредниците, трговијата на големо и мало.',
    stigTitle: 'Патот на STIG ROCK',
    stigSteps: [
      'Директно купување — Сурови Diamond од рудник',
      'Брусење и сертификација преку нашите Partner-и',
      'Продажба на крајни клиенти и B2B клиенти',
      'До 4 трговски циклуси годишно'
    ],
    stigNote: 'Ние го прекинуваме циклусот и ги пренесуваме трговските маржи како одобрени попусти на нашите клиенти — до 4 трговски циклуси за време на DS-Plan периодот.'
  },
  optionen: {
    overline: 'Вашите можности',
    title: 'По истекот на вашиот Solution план',
    items: [
      { title: 'Испорака', body: 'Diamond (Karat) по цената на вашиот DS-Plan.' },
      { title: 'Продажба нам', body: 'Препродажба по куповната цена што сте ја платиле.' },
      { title: 'Продажба на трети лица', body: 'Продажба на Diamond на слободниот пазар.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution планови — единствена иновација на производ',
    title: 'Едноставниот пат',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Регистрација',
        body: 'Контактирајте го вашето лице за препорака и креирајте бесплатна сметка!'
      },
      { n: '02', icon: 'cart', title: 'Купување производ', body: 'Веќе од $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Добивање попусти',
        body: 'Добивајте месечни одобрени попусти.'
      }
    ]
  },
  business: {
    overline: 'Видови бонуси',
    title: 'Наједноставниот и најфер пат.',
    sub: 'Пет видови бонуси — за вашето успешно градење бизнис.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'До Level 3, од кариерно ниво Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Од Sapphire — до бесконечна длабочина.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'На Infinity Bonus – до Level 5 · БЕЗ квалификација.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 Pools од светскиот промет.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Еднократен бонус во Diamond (Karat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Овој бонус ви се исплаќа за секој новопотпишан Solution план до 3-то ниво. Со многу мали квалификации ги отклучувате поединечните нивоа.',
    total: 'До 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'од самиот почеток',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'од кариерно ниво Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'од кариерно ниво Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Од кариерното ниво Sapphire сте квалификувани за нашиот Infinity Bonus план. Добивате 3% бонус. Со секое ново кариерно ниво се додаваат дополнителни проценти. Доколку некој Partner во вашиот тим е исто така квалификуван, ја добивате разликата од ранг до ранг.',
    exampleTitle: 'Пример',
    exampleRows: [
      { label: 'Вие сте Blue Diamond', value: '12%' },
      { label: 'Вашиот Partner е Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Вашиот Infinity Bonus', value: '9%' },
    totalNote: 'Вкупно до 24% Infinity Bonus на сите потпишани Solution планови во вашиот тим — до бесконечна длабочина.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Со овој бонус профитирате од успехот на вашиот тим. Добивате Matching Bonus од 5% на Infinity Bonus на вашите Partner-и — и тоа до 5-то ниво во вашиот тим.',
    note: 'На сите исплати на Infinity Bonus во вашиот тим – до 5-то ниво. Од самиот почеток – БЕЗ квалификација.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Вкупно до',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% од светскиот промет се слеваат во еднакви делови во 3 различни Pools. Со достигнување на одредени кариерни нивоа, се квалификувате за секој поединечен Pool.',
    forever: 'Еднаш достигнато – ЗАСЕКОГАШ учествувате!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'од Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'од Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'од Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Вкупно',
    totalValue: '3%',
    totalSuffix: 'од светскиот промет'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Од кариерното ниво Diamond добивате Rang Bonus. Овој бонус се исплаќа во Diamond (Karat). Станува збор за еднократен бонус.',
    highlight: 'Diamond (Karat) во вкупна вредност од',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Кариерни нивоа',
    title: 'Кариерни нивоа',
    sub: 'За достигнување на соодветните кариерни нивоа се смета историскиот вкупен промет (HG). Овој промет од нивото Sapphire па нагоре мора да биде распределен на повеќе тимови. За да постигнете Ruby или повисоко, потребни ви се најмалку два директни Partner-и со Solution план.',
    forever: 'Еднаш достигнато – ЗАСЕКОГАШ потврдено!',
    footnote: 'HV = Историски вкупен промет.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 дир. Partner', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Започнете со нас',
    title: 'Вистинското време е токму сега.',
    body: 'Овој бизнис модел поставува нови стандарди и ги обединува сите фактори на успех за долгорочно одржлив и успешен бизнис. Регистрирајте се уште денес, изберете го вашиот Solution план и искористете ја оваа уникатна деловна можност.',
    hint: 'Разговарајте со лицето кое ве покани на оваа презентација — тоа има линк за регистрација за вас.',
    formName: 'Име',
    formEmail: 'Е-пошта',
    formPhone: 'Телефон',
    formSubmit: 'Контактирајте нè',
    success: 'Ви благодариме — ќе ве контактираме дискретно и лично.',
    callCta: 'Јавете се',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Правна напомена & Disclaimer',
    disclaimer: 'Оваа презентација служи исклучиво за информирање и не претставува финансиски, инвестициски или даночен совет. STIG ROCK не е финансиски производ, туку се однесува на природни Diamond како реални средства. За развој на вредноста, добивката или приносите не се презема никаква гаранција. Минатите случувања не се индикација за идните резултати. Сите прикажани пресметки во врска со провизиите се само примери и исто така не претставуваат гаранција. Го задржуваме правото на измени на содржината — слободен превод (не е официјален превод).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Сите права се задржани.',
    version: 'Верзија: DS-12-2025 V3'
  },
  misc: { next: 'Следна секција' }
};

export default mk;
